<template>
  <jczh-drawer
    :title="title"
    :visible.sync="visible"
    size="700px"
    :el-attrs="{
      destroyOnClose: true
    }"
    @confirm="handleConfirm"
    @close="clearDialog"
  >
    <template v-slot:content>
      <el-form
        ref="materielForm"
        size="small"
        class="m-t-20"
        label-width="160px"
        :model="material"
        :rules="formRules"
        label-suffix="："
      >
        <!--品目编码-->
        <el-form-item
          v-if="'itemCode' in translateObject"
          :label="translateObject.itemCode.label"
          :prop="translateObject.itemCode.key"
        >
          <el-input
            v-model.trim="material[translateObject.itemCode.key]"
            :placeholder="`请输入${translateObject.itemCode.label}`"
            maxlength="25"
            show-word-limit
          />
        </el-form-item>

        <!--品目名称-->
        <el-form-item
          v-if="'itemName' in translateObject"
          :label="translateObject.itemName.label"
          :prop="translateObject.itemName.key"
        >
          <el-input
            v-model.trim="material[translateObject.itemName.key]"
            :placeholder="`请输入${translateObject.itemName.label}`"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>

        <!--参数型号-->
        <el-form-item
          v-if="'itemModel' in translateObject"
          :label="translateObject.itemModel.label"
          :prop="translateObject.itemModel.key"
        >
          <el-input
            v-model.trim="material[translateObject.itemModel.key]"
            :placeholder="`请输入${translateObject.itemModel.label}`"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>

        <!--品牌/制造商-->
        <el-form-item
          v-if="'itemBrand' in translateObject"
          :label="translateObject.itemBrand.label"
          :prop="translateObject.itemBrand.key"
        >
          <el-input
            v-model.trim="material[translateObject.itemBrand.key]"
            :placeholder="`请输入${translateObject.itemBrand.label}`"
            maxlength="50"
            show-word-limit
          />
        </el-form-item>

        <!--单位-->
        <el-form-item
          v-if="'unitType' in translateObject"
          :label="translateObject.unitType.label"
          :prop="translateObject.unitType.key"
        >
          <el-select
            v-model="material[translateObject.unitType.key]"
            style="width: 100%"
            filterable
            remote
            allow-create
            default-first-option
            :placeholder="
              `请输入${translateObject.unitType.label}，示例：台、个、千米`
            "
            :remote-method="getUnitOptions"
            :disabled="isUnitTypeDisabled"
          >
            <el-option
              v-for="item in unitOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <!--数量-->
        <el-form-item
          v-if="'itemNum' in translateObject"
          :label="translateObject.itemNum.label"
          :prop="translateObject.itemNum.key"
        >
          <el-input-number
            v-model="material[translateObject.itemNum.key]"
            class="left-input-number"
            :min="0"
            :max="9999999999.99"
            :precision="2"
            :placeholder="`请输入${translateObject.itemNum.label}`"
            :controls="false"
            style="width: 200px"
          />
        </el-form-item>

        <!--预算单价(元)-->
        <el-form-item
          v-if="'unitPrice' in translateObject"
          :label="translateObject.unitPrice.label"
          :prop="translateObject.unitPrice.key"
          class="inline-item"
        >
          <el-input-number
            v-model="material[translateObject.unitPrice.key]"
            class="left-input-number"
            :placeholder="`请输入${translateObject.unitPrice.label}`"
            :min="0"
            :max="99999999999.99"
            :precision="2"
            :controls="false"
            style="width: 200px"
          />
        </el-form-item>

        <!--预算总价(元)-->
        <el-form-item
          v-if="'totalPrice' in translateObject"
          :label="translateObject.totalPrice.label"
          :prop="translateObject.totalPrice.key"
          class="inline-item"
        >
          <el-input v-model="totalPrice" placeholder="请输入总价" disabled />
        </el-form-item>

        <!--税率(%)-->
        <el-form-item
          v-if="'taxRate' in translateObject"
          :label="translateObject.taxRate.label"
          :prop="translateObject.taxRate.key"
          class="inline-item"
        >
          <!--<el-input-number-->
          <!--  v-model="material[translateObject.taxRate.key]"-->
          <!--  class="left-input-number"-->
          <!--  :placeholder="`请输入${translateObject.taxRate.label}`"-->
          <!--  :min="0"-->
          <!--  :max="100"-->
          <!--  :precision="2"-->
          <!--  :controls="false"-->
          <!--  style="width: 200px"-->
          <!--/>-->
          <el-select
            v-model="material[translateObject.taxRate.key]"
            filterable
            allow-create
            default-first-option
            :placeholder="`请输入${translateObject.taxRate.label}`"
          >
            <el-option
              v-for="item in taxRateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <!-- 工厂编码 -->
        <el-form-item
          v-if="'factory' in translateObject"
          :label="translateObject.factory.label"
          :prop="translateObject.factory.key"
          class="inline-item"
        >
          <el-select
            v-if="!isFactoryDisabled"
            v-model="material[translateObject.factory.key]"
            filterable
            default-first-option
            :placeholder="`请选择${translateObject.factory.label}`"
            @change="factoryChange"
          >
            <el-option
              v-for="item in factoryOptions"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
          <span v-else>{{ material[translateObject.factory.key] }}</span>
        </el-form-item>

        <!--交货地点-->
        <el-form-item
          v-if="'deliveryAddress' in translateObject"
          :label="translateObject.deliveryAddress.label"
          :prop="translateObject.deliveryAddress.key"
        >
          <el-select
            v-if="isAddressSelect"
            v-model="material[translateObject.deliveryAddress.key]"
            :placeholder="`请选择${translateObject.deliveryAddress.label}`"
          >
            <el-option
              v-for="item in deliveryAddressOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>

          <el-input
            v-else
            v-model="material[translateObject.deliveryAddress.key]"
            maxlength="100"
            show-word-limit
            :placeholder="`请输入${translateObject.deliveryAddress.label}`"
          />
        </el-form-item>

        <!--交货时间(天)-->
        <el-form-item
          v-if="'deliveryDay' in translateObject"
          :label="translateObject.deliveryDay.label"
          :prop="translateObject.deliveryDay.key"
          class="inline-item"
        >
          <el-input-number
            v-model="material[translateObject.deliveryDay.key]"
            class="left-input-number"
            :placeholder="`请输入${translateObject.deliveryDay.label}`"
            :min="0"
            :max="9999"
            :controls="false"
          />
        </el-form-item>

        <!-- 使用部门 -->
        <el-form-item
          v-if="'useDept' in translateObject"
          :label="translateObject.useDept.label"
          :prop="translateObject.useDept.key"
          class="inline-item"
        >
          <el-input
            v-model="material[translateObject.useDept.key]"
            maxlength="50"
            placeholder="请输入"
          />
        </el-form-item>

        <!-- 科目分配类别 -->
        <el-form-item
          v-if="'subType' in translateObject"
          :label="translateObject.subType.label"
          :prop="translateObject.subType.key"
          class="inline-item"
        >
          <el-select
            v-model="material[translateObject.subType.key]"
            :placeholder="`请选择${translateObject.subType.label}`"
          >
            <el-option
              v-for="item in purchaseDemandSubTypeDict.array"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <!-- 采购执行人 -->
        <el-form-item
          v-if="'executorName' in translateObject"
          :label="translateObject.executorName.label"
          :prop="translateObject.executorName.key"
          class="inline-item"
        >
          <el-input
            v-model="material[translateObject.executorName.key]"
            :placeholder="`请选择${translateObject.executorName.label}`"
            @focus="showSelectEmployeeDialog = true"
          />
        </el-form-item>

        <!--备注-->
        <el-form-item
          v-if="'remarks' in translateObject"
          :label="translateObject.remarks.label"
          :prop="translateObject.remarks.key"
        >
          <el-input
            v-model.trim="material[translateObject.remarks.key]"
            type="textarea"
            :placeholder="`请输入${translateObject.remarks.label}`"
            :autosize="{ minRows: 6 }"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>

        <!--附件上传-->
        <el-form-item
          v-if="'fileGroupId' in translateObject"
          :label="translateObject.fileGroupId.label"
          :prop="translateObject.fileGroupId.key"
        >
          <upload
            ref="uploadFile"
            :props-data="{
              limit: 1,
              bizType: bizType,
              attachmentType: attachmentType,
              groupIdBefore: materialInfo[translateObject.fileGroupId.key],
              onSuccess: groupId =>
                (material[translateObject.fileGroupId.key] = groupId),
              onCompleteDelete: () =>
                (material[translateObject.fileGroupId.key] = '')
            }"
          />
        </el-form-item>
      </el-form>

      <!--采购执行人-->
      <select-employee-dialog
        title="选择采购执行人"
        :show-dialog.sync="showSelectEmployeeDialog"
        @confirm="setExecutorConfirm"
      />
    </template>
  </jczh-drawer>
</template>

<script>
import { cloneDeep } from 'lodash'
import { unitOptions, unitTaxRateDict } from '@/dictionary/project/common'
import { purchaseDemandSubTypeDict } from '@/dictionary/purchase-demand'

import Upload from '@/components/common/Upload/index'
import SelectEmployeeDialog from '@/components/common/SelectEmployeeDialog'

// 后端api
import {
  getPurchaseFactoryListApi,
  getPurchaseAddressByFactoryApi
} from '@/api/purchase-demand/address'

export default {
  name: 'AddOrEditMaterialInfoDialog',

  components: { Upload, SelectEmployeeDialog },

  model: {
    prop: 'showDialog',
    event: 'change'
  },

  props: {
    showDialog: {
      type: Boolean,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    materialField: {
      type: Array,
      required: true
    },

    // 品目信息
    materialInfo: {
      type: Object,
      default: () => {}
    },

    // 上传组件需要的定义参数
    uploadParams: {
      type: Object,
      default: () => {
        return {
          bidType: '',
          attachmentType: ''
        }
      }
    },

    // 品目编码是否必填
    itemCodeRequired: {
      type: Boolean,
      default: true
    },

    // 工厂编码是否不可编辑
    isFactoryDisabled: {
      type: Boolean,
      default: false
    },

    // 交货地址是否是下拉选择
    isAddressSelect: {
      type: Boolean,
      default: false
    },

    // 交货地址是否必填
    addressRequired: {
      type: Boolean,
      default: false
    },

    // 税率列表
    taxRateOptions: {
      type: Array,
      default: () => {
        return unitTaxRateDict.dictArray
      }
    },

    // 品目单位是否不可编辑
    isUnitTypeDisabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    // 校验函数
    const checkUnitPrice = (rule, value, callback) => {
      if (value == 0) {
        callback(new Error('品目单价不能为0'))
      } else if (value < 0) {
        callback(new Error('品目单价不能为负数'))
      } else {
        callback()
      }
    }

    const checkSubType = (rule, value, callback) => {
      if (!value && value !== '') {
        callback(new Error('请选择科目分配类别'))
      } else {
        callback()
      }
    }

    return {
      purchaseDemandSubTypeDict,

      loading: false,
      unitOptions: [], // 品目单位数据字典

      factoryOptions: [], // 工厂编码下拉列表
      deliveryAddressOptions: [], // 收货地点下拉列表

      // 初始值信息
      initialInfo: {
        itemCode: '', // 品目编码
        itemName: '', // 品目名称
        itemNum: undefined, // 数量
        itemModel: '', // 参数型号
        itemBrand: '', // 品牌/制造商
        unitPrice: undefined, // 预算单价
        totalPrice: 0, // 总价，总价禁止填写，根据数量和预算单价自动计算
        taxRate: '13', // 税率
        unitType: '', // 单位
        factory: '', // 工厂编码
        deliveryAddress: '', // 交货地点
        deliveryDay: '', // 交货天
        useDept: '', // 使用部门
        subType: undefined, // 科目分配类别
        executorName: '', // 采购执行人
        executorId: '', // 采购执行人id
        remarks: '', // 备注
        fileGroupId: '' // 附件组id
      },

      // 品目表单
      material: {},

      // 根据formRulesTemp生成的表单校验规则
      formRules: {},

      // 表示默认字段对应的新字段，以及label
      translateObject: {},

      // 表单校验规则（提供生成的中间检验规则）
      formRulesDict: {
        itemCode: [
          {
            required: this.itemCodeRequired,
            message: '请输入品目编码',
            trigger: ['blur', 'change']
          },
          {
            pattern: /^[A-Za-z0-9\-_]+$/,
            message: '品目编码只接受字母或数字',
            trigger: ['blur']
          }
        ],
        itemName: [
          {
            required: true,
            message: '请输入品目名称',
            trigger: ['blur', 'change']
          }
        ],
        itemNum: [
          {
            required: true,
            message: '请输入品目数量',
            trigger: ['blur', 'change']
          },
          {
            pattern: /^(([1-9]\d*)|0)(\.\d{0,2})?$/,
            message: '请输入仅包含小数点两位的有效数字',
            trigger: 'blur'
          }
        ],
        unitPrice: [
          {
            required: true,
            message: '请输入品目单价',
            trigger: ['blur', 'change']
          },
          {
            pattern: /^(([1-9]\d*)|0)(\.\d{0,2})?$/,
            message: '请输入仅包含小数点两位的有效数字',
            trigger: 'blur'
          },
          {
            validator: checkUnitPrice,
            trigger: 'blur'
          }
        ],
        unitType: [
          {
            required: true,
            message: '请输入单位',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              if (value.length > 10) {
                callback(new Error('单位长度不能超过10个字符'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        taxRate: {
          pattern: /^(([1-9]\d*)|0)(\.\d{0,2})?$/,
          message: '请输入仅包含小数点两位的有效数字',
          trigger: 'blur'
        },
        factory: [
          {
            required: !this.isFactoryDisabled,
            message: '请选择工厂编码',
            trigger: ['blur', 'change']
          }
        ],
        deliveryAddress: [
          {
            required: this.addressRequired,
            message: `请${this.isAddressSelect ? '选择' : '输入'}交货地址`,
            trigger: ['blur', 'change']
          }
        ],
        useDept: [
          {
            required: true,
            message: `请输入使用部门`,
            trigger: 'blur'
          }
        ],
        subType: [
          {
            required: true,
            validator: checkSubType,
            trigger: ['blur', 'change']
          }
        ],
        executorName: [
          {
            required: true,
            message: '请选择采购执行人',
            trigger: ['change']
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请选择采购执行人'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },

      // 采购执行人弹窗
      showSelectEmployeeDialog: false
    }
  },

  computed: {
    visible: {
      get() {
        return this.showDialog
      },
      set(val) {
        this.$emit('change', val)
      }
    },

    //  总价
    totalPrice() {
      let price = 0
      if (this.material[this.translateObject.itemNum.key]) {
        price = (
          (this.material[this.translateObject.itemNum.key] *
            100 *
            (this.material[this.translateObject.unitPrice.key] * 100)) /
          10000
        ).toFixed(2)
      }
      return isNaN(price) ? 0 : price
    },

    bizType() {
      return this.uploadParams.bizType
    },

    attachmentType() {
      return this.uploadParams.attachmentType
    }
  },

  watch: {
    showDialog(newVal) {
      if (newVal) {
        this.material = Object.assign(
          {},
          this.material,
          this.materialInfo || {}
        )

        // 工厂编码
        if ('factory' in this.translateObject) {
          !this.isFactoryDisabled && this.getFactoryList()
          const factory = this.material[this.translateObject.factory.key]
          this.isAddressSelect && factory && this.getAddressList(factory)
        }
      }
    },

    materialField: {
      handler: function(fileList) {
        const temp = this.initialInfo || {}

        const formDataTemp = {}
        const formRulesTemp = {}
        const translateObjectTemp = {}
        fileList.forEach(value => {
          // 动态计算form表单对象
          if (value.prop in temp) {
            if (value.transProp) {
              formDataTemp[value.transProp] = temp[value.prop]
              translateObjectTemp[value.prop] = {
                key: value.transProp,
                label: value.label
              }
            } else {
              formDataTemp[value.prop] = temp[value.prop]
              translateObjectTemp[value.prop] = {
                key: value.prop,
                label: value.label
              }
            }

            // 附加字段
            if (value.addFields) {
              const tempFields = value.addFields.split(',')
              tempFields.forEach(field => {
                formDataTemp[field] = temp[field]
                translateObjectTemp[field] = { key: field, label: '' }
              })
            }
          }

          // 动态计算formRules校验规则
          if (value.prop in this.formRulesDict) {
            if (value.transProp) {
              formRulesTemp[value.transProp] = this.formRulesDict[value.prop]
            } else {
              formRulesTemp[value.prop] = this.formRulesDict[value.prop]
            }
          }
        })
        this.material = formDataTemp
        this.formRules = formRulesTemp
        this.translateObject = translateObjectTemp
      },
      immediate: true
    }
  },

  methods: {
    // 关闭对话框时，执行的函数
    clearDialog() {
      // 对整个表单进行重置，将所有字段值重置为初始值并移除校验结果
      this.$refs.materielForm.resetFields()

      // 当前品目信息清空为初始值
      for (const k in this.material) {
        this.material[k] = this.initialInfo[k]
      }
    },

    // 模拟远程获取单位
    getUnitOptions(query) {
      query = query.trim()
      if (!query) {
        this.unitOptions = []
        return
      }

      this.unitOptions = unitOptions.filter(unit => {
        return unit.label.indexOf(query) > -1
      })
    },

    /**
     * 获取工厂编码下拉列表
     */
    async getFactoryList() {
      await getPurchaseFactoryListApi()
        .then(res => {
          const data = res.data || []
          this.factoryOptions = data
        })
        .catch(err => {
          this.$message.error(err.message || '获取工厂编码失败')
        })
    },

    /**
     * 获取交货地点下拉列表
     */
    getAddressList(factory) {
      getPurchaseAddressByFactoryApi(factory)
        .then(res => {
          const data = res.data || []
          this.deliveryAddressOptions = data.map(item => ({
            value: `${item.addressCode},${item.addressName}`,
            label: item.addressName
          }))
        })
        .catch(err => {
          this.$message.error(err.message || '获取交货地点失败')
        })
    },

    /**
     * 工厂编码切换
     */
    factoryChange(value) {
      this.$set(this.material, this.translateObject.deliveryAddress.key, '')
      this.getAddressList(value)
    },

    /**
     * 采购执行人确认
     */
    setExecutorConfirm(employee) {
      if (employee) {
        this.$set(this.material, this.translateObject.executorName.key, employee.name)
        this.$set(this.material, this.translateObject.executorId.key, employee.employeeId)
      }
    },

    // 点击确定
    handleConfirm() {
      if (this.$refs.uploadFile && !this.$refs.uploadFile.uploadComplete()) {
        return false
      }

      this.$refs.materielForm.validate().then(valid => {
        if (valid) {
          if (this.translateObject.totalPrice) {
            this.material[this.translateObject.totalPrice.key] = this.totalPrice
          }
          const tempData = cloneDeep(this.material)
          this.$emit('material', tempData)
          this.$emit('change', false)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog--center .el-dialog__body {
  padding-bottom: 0;
  padding-left: 10px;
}

::v-deep .el-input-number {
  &.left-input-number {
    .el-input__inner {
      text-align: left;
    }
    input::placeholder {
      text-align: left !important;
    }
  }
}
</style>
